import React from "react";
import {connect} from "react-redux";
import {getTranslate, TranslateFunction} from "react-localize-redux";
import {Button, message} from "antd";
import Icon, { CheckCircleOutlined } from "@ant-design/icons";
import StoreState from "../../../../interfaces/store/storeState";
import "./UniqueJobId.scss";
import {CopyUniqueJobId} from "../../../../assets/icons";
import {formatString} from "../../../../utils/common";

interface StateProps {
    translate: TranslateFunction
    codename: string
}

type Props = StateProps;

const UniqueJobId: React.FC<Props> = ({codename, translate}: Props): React.ReactElement => {
    const translationPath: string = "components.JobInfo.UniqueJobId.UniqueJobId";

    /**
     * Copy Job id to clipboard
     */
    function copyToClipBoard(): void {
        navigator.clipboard
            .writeText(codename)
            .then((): void => {
                message.success({
                    content: translate(`${translationPath}.success.text`),
                    icon: <CheckCircleOutlined/>,
                    duration: 2,
                });
            });
    }

    return (
        <div className="df-unique-job-id">
            {translate(`${translationPath}.label.text`)}
            <Button type="ghost" onClick={copyToClipBoard}>
                <span>
                    {formatString(translate(`${translationPath}.codeNameFormat.text`) as string, codename)}
                </span>
                <Icon component={CopyUniqueJobId}/>
            </Button>
        </div>
    );
};

function mapStateToProps({localize, job: {jobDetails}}: StoreState): StateProps {
    return {
        codename: jobDetails?.codename ?? "",
        translate: getTranslate(localize),
    };
}

export default connect(mapStateToProps)(UniqueJobId);
